import {
    SET_NOTIFICATION_LIST,
    SET_NOTIFICATION_TOTAL_COUNT,
    SET_NOTIFICATION_UNREAD_COUNT,
    INCREMENT_NOTIFICATIONS_UNREAD_COUNT
} from "../actions/notificationActions";

const initialState = {
    notifications: [],
    notificationsTotalCount: 0,
    notificationsTotalUnreadCount: 0
};

const notificationReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_NOTIFICATION_LIST:
            return {
                ...state,
                notifications: action.payload
            };
        case SET_NOTIFICATION_TOTAL_COUNT:
            return {
                ...state,
                notificationsTotalCount: action.payload
            };
        case SET_NOTIFICATION_UNREAD_COUNT:
            return {
                ...state,
                notificationsTotalUnreadCount: action.payload
            };
        case INCREMENT_NOTIFICATIONS_UNREAD_COUNT:
            return {
                ...state,
                notificationsTotalUnreadCount: state.notificationsTotalUnreadCount + 1
            };
        default:
            return state;
    }
};

export default notificationReducer;
